import { Button } from '@/components/ui/button';
import { Loader2, Sparkles } from 'lucide-react';

interface GenerateButtonProps {
  onClick: () => void;
  generating: boolean;
  label: string;
  loadingLabel?: string;
  variant?: 'default' | 'outline' | 'secondary';
  size?: 'default' | 'sm';
  disabled?: boolean;
}

export function GenerateButton({
  onClick,
  generating,
  label,
  loadingLabel,
  variant = 'outline',
  size = 'sm',
  disabled = false,
}: GenerateButtonProps) {
  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={generating || disabled}
    >
      {generating ? (
        <>
          <Loader2 className="mr-2 h-3.5 w-3.5 animate-spin" />
          {loadingLabel || 'Generowanie...'}
        </>
      ) : (
        <>
          <Sparkles className="mr-2 h-3.5 w-3.5" />
          {label}
        </>
      )}
    </Button>
  );
}
